import React, { Fragment, useState, useEffect } from 'react';
import { Card, Form, Table, Button } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { serviceGetProcesosJudiciales } from '../../../../../api/api-confirmar-cierre';
import Implicados from './implicados';
import { LoadingComponent } from 'recupero-comunes';


const Procesos = ({ cfg_form, idProcesoJud }) => {
    const data_encargado = useSelector((state) => state.encargadoCompaniaReducer);
    const { llaves } = data_encargado;
    const [loading, setLoading] = useState(false);
    const [procesos, setProcesos] = useState([]);

    const [showImplicados, setShowImplicados] = useState(false);
    const [procesoSelected, setProcesoSelected] = useState(null);

    useEffect(() => {
        getProcesosJudiciales();
    }, [])

    useEffect(() => {
        const auxBools = [];
        procesos.forEach(_ => auxBools.push(true));
    }, [procesos])

    useEffect(() => {
        if (procesos.length > 0 && idProcesoJud) {
            const preseleccionado = procesos.find(p => p.idInstancia === idProcesoJud);
            if (preseleccionado) handleImplicados(preseleccionado);
        }
    }, [procesos, idProcesoJud])

    const getProcesosJudiciales = async () => {
        setLoading(true);
        let query = Buffer.from(JSON.stringify({ idCaso: llaves.idCaso })).toString('base64');
        const response = await serviceGetProcesosJudiciales(query);

        setLoading(false);
        setProcesos(response);
    }

    const handleImplicados = (selected) => {
        setShowImplicados(true);
        setProcesoSelected(selected);
    }

    return (
        <Fragment>
            <LoadingComponent show={loading} />

            <hr style={{ borderTop: '3px solid #04005D' }}></hr>
            <Card>
                <Card.Body className="customCard">
                    <Table striped className="customTable">
                        <thead>
                            <tr>
                                <th style={{ textAlign: 'center' }}></th>
                                <th style={{ textAlign: 'center' }}>{cfg_form && cfg_form["modalconsultacierre-grillaprocesos-competencia"]}</th>
                                <th style={{ textAlign: 'center' }}>{cfg_form && cfg_form["modalconsultacierre-grillaprocesos-jurisdiccion"]}</th>
                                <th style={{ textAlign: 'center' }}>{cfg_form && cfg_form["modalconsultacierre-grillaprocesos-dptomun"]}</th>
                                <th style={{ textAlign: 'center' }}>{cfg_form && cfg_form["modalconsultacierre-grillaprocesos-nroradicado"]}</th>
                                <th style={{ textAlign: 'center' }}>{cfg_form && cfg_form["modalconsultacierre-grillaprocesos-fechaing"]}</th>
                                <th style={{ textAlign: 'center', width: '12%' }}>{cfg_form && cfg_form["modalconsultacierre-grillaprocesos-ulthito"]}</th>
                                <th style={{ textAlign: 'center', width: '10%' }}>{cfg_form && cfg_form["modalconsultacierre-grillaprocesos-fechahito"]}</th>
                                <th style={{ textAlign: 'center' }}>{cfg_form && cfg_form["modalconsultacierre-grillaprocesos-estado"]}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {procesos.map((proceso, index) => (
                                <tr key={index}>
                                    <td >
                                        <Form.Check
                                            type="radio"
                                            name="group1"
                                            id={`radio-${index}`}
                                            checked={procesoSelected?.idInstancia === proceso.idInstancia}
                                            onChange={() => handleImplicados(proceso)}
                                        />
                                    </td>
                                    <td>{proceso.competencia}</td>
                                    <td>{proceso.juridiccion}</td>
                                    <td>{proceso.departamento}/{proceso.municipio}</td>
                                    <td>{proceso.rolCausa}</td>
                                    <td>{proceso.fecIngresaCausaFormat}</td>
                                    <td>{proceso.glosaUltimoHito}</td>
                                    <td>{proceso.fecUltHitoJudicialFormat}</td>
                                    <td>{proceso.glosaEstado}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                    {procesos?.length === 0 &&
                        <span style={{ display: 'inherit', textAlign: 'center' }}>No hay registros encontrados.</span>
                    }
                </Card.Body>
            </Card>

            {showImplicados && <Implicados cfg_form={cfg_form} implicados={procesoSelected?.implicados} />}

            <style type='text/css'>
                {`
                    .customCard {
                        padding-top: 0;
                        padding-left: 0;
                        padding-right: 0;
                    }
                    .customTable > thead {
                        color: white; 
                        background-color: rgb(114, 139, 176);
                    }
                    .customTable > thead > tr > th {
                        padding: 20px 0;
                    }
                `}
            </style>
        </Fragment>
    )
}

export default Procesos;